import { Auth } from "aws-amplify";

class AuthService {
  /**
   * login with amplify using email and password
   * @param {*} username
   * @param {*} password
   */
  async login(username, password) {
    try {
      const user = await Auth.signIn(username, password);
      return {
        email: user?.attributes?.email,
        emailVerified: user?.attributes?.email_verified,
        userId: user?.attributes["custom:gsnUserId"],
        signedIn: true,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async logOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }


  async getCurrentUserAmplify() {
    try {
      const session = await Auth.currentSession();
      const isValid = session.isValid();

      if (isValid) {
        try {
          // Force token validation by making an authenticated request
          await Auth.currentAuthenticatedUser({ bypassCache: true });
          return {
            email: session.getIdToken().decodePayload().email,
            emailVerified: session.getIdToken().decodePayload().email_verified,
            signedIn: true
          };
        } catch (validationError) {
          // Token invalidated server-side
          await Auth.signOut(); // Clear local tokens
          return { signedIn: false };
        }
      }
    } catch (err) {
      return { signedIn: false };
    }
  }



}

const authService = new AuthService();

export default authService;
